import { formatUsd } from 'shared';
import { cartDueToday, cartGrandTotal, cartMonthlyTotal } from '@/state/pricing.js';
import { OutreachOrderLines } from '@/flows/outreach/components/order-lines.js';

/** The review before checkout — the marketplace order summary's counterpart. */
export function OutreachSummaryCard() {
  const grand = cartGrandTotal.value;
  const monthly = cartMonthlyTotal.value;

  return (
    <div className="sm-panel sm-stack sm-animate-in sm-chat-tail sm-chat-form-card">
      <OutreachOrderLines />

      <div className="sm-stack sm-totals">
        <div className="sm-type-body sm-tabular sm-totals-row">
          <span>Tax</span>
          <span>{formatUsd(grand.taxes)}</span>
        </div>
        <div className="sm-type-body sm-tabular sm-totals-row">
          <span>Order total</span>
          <span>{formatUsd(grand.total)}</span>
        </div>
        {monthly !== null && (
          <div className="sm-type-body sm-tabular sm-totals-row">
            <span>Then monthly</span>
            <span>{formatUsd(monthly)}/mo</span>
          </div>
        )}
      </div>

      <div className="sm-stack sm-totals sm-totals-due">
        <div className="sm-type-heading sm-tabular sm-totals-row" data-tone="total">
          <span>Due today</span>
          <span>{formatUsd(cartDueToday.value)}</span>
        </div>
      </div>
    </div>
  );
}
